import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const VALIDATE_ENTERED_CODE = "VALIDATE_ENTERED_CODE";

export const service = async (codes) => {
  const options: object = {
    url: "/api/lookup/ValidateEnteredCode",
    method: "POST",
    body: JSON.stringify(codes),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(VALIDATE_ENTERED_CODE, service, mock);
